import React, { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { userXMenuAdd, userXMenuDelete } from "../reducers/users-page-actions";
import { selectMenus, selectUsersXMenu } from "../users-selectors";
import {
  Checkbox,
  FormControlLabel,
  List,
  ListItemText,
  Paper,
  Stack,
} from "@mui/material";
import { Body1, H6 } from "../../../../components";

const STR = {
  titleUsersXMenu: "Usuários x Menu",
  subtitleUsersXMenu: "Atribuição e retirada de menus aos usuários",
};

const menuInUser = (userId, menuId, usersXMenu) => {
  if (!usersXMenu.hasOwnProperty(userId)) return false;
  return usersXMenu[userId].includes(menuId);
};

function UsersXMenu({ id }) {
  const dispatch = useDispatch();
  const menus = useSelector(selectMenus);
  const usersXMenus = useSelector(selectUsersXMenu);
  //
  const toggleVarInUser = useCallback(
    (value, menuId) => {
      if (value) {
        dispatch(
          userXMenuAdd({
            id_usuario: id,
            id_menu: menuId,
          })
        );
      } else {
        dispatch(
          userXMenuDelete({
            id_usuario: id,
            id_menu: menuId,
          })
        );
      }
    },
    [dispatch, id]
  );
  return (
    <Stack>
      <H6>{STR.titleUsersXMenu}</H6>
      <Body1 align="center">{STR.subtitleUsersXMenu}</Body1>
      <List disablePadding dense>
        {menus?.map((inMenu) => (
          <Paper key={inMenu.id} sx={{ p: 0.5, my: 1 }}>
            <MenuInfoItem
              name={inMenu.nome}
              family={inMenu.familia}
              id={inMenu.id}
              onToggle={toggleVarInUser}
              isChecked={
                usersXMenus ? menuInUser(id, inMenu.id, usersXMenus) : false
              }
            />
          </Paper>
        ))}
      </List>
    </Stack>
  );
}

const MenuInfoItem = ({ id, name, family, isChecked, onToggle }) => {
  return (
    <FormControlLabel
      checked={isChecked}
      onChange={(e) => onToggle(e.target.checked, id)}
      control={<Checkbox />}
      label={<ListItemText primary={name} secondary={family} />}
    />
  );
};

export default UsersXMenu;
